module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _vm._v("Copyright © 2019 by University of Massachusetts Press")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("ISBN 978-1-61376-689-7 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Cover design by Thomas Eykemans")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover photo by Idaho Sagebrush, Fallujah, 2004, www.flickr.com/photos/idahosagebrush/9197397204/. Licensed under https://creativecommons.org/licenses/by/2.0/.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Names: Caputi, Ross, author. | Hill, Richard, 1949–author. | Mulhearn,Donna, author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: The sacking of Fallujah : a people’s history / Ross Caputi, Richard Hill, and Donna Mulhearn.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Amherst : University of Massachusetts Press, 2019. | Series: Culture and politics in the Cold War and beyond | Includes bibliographical references and index. |")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: LCCN 2018051545 (print) | LCCN 2018055901 (ebook) | ISBN")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("9781613766880 (ebook) | ISBN 9781613766897 (ebook) | ISBN 9781625344373 |")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("ISBN 9781625344373(hardcover) | ISBN 9781625344380(pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: LCSH: Fall?ujah (Iraq)—History—21st century. | Fallujah, Battle of, Fall?ujah, Iraq, 2004. | Iraq War, 2003–2011—Campaigns—Iraq—Fall?ujah. | IS (Organization)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: LCC DS79.764.F35 (ebook) | LCC DS79.764.F35 C37 2019 (print) | DDC 956.7044/342—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC record available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://lccn.loc.gov/2018051545",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2018051545")])]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("British Library Cataloguing-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("A catalog record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('i', [_vm._v("All photos in the gallery by Donna Mulhearn.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-694aff51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma-CAPUTI-0005.vue
// module id = 69
// module chunks = 0